import * as types from "../../constants"
import * as actions from "../actions-declarations/unitImage";
import { ActionsOf, init } from "../utils";

export type UnitImageActions = typeof actions;

const defaultState = {
    loading: true,
    unitImages: null as null | any[],
    unitImagesByCompanyId: [] as any[],
    unitImagesByPropertyId: [] as any[],
    unitImagesCount: null as null | number
}

export default function reducer(
  state = init(defaultState),
  actions: ActionsOf<UnitImageActions>): typeof state {
    switch (actions.type) {
        case types.FETCH_UNIT_IMAGES:
            return {
                ...state,
                unitImages: actions.payload
            };
        case types.FETCH_UNIT_IMAGES_BY_PROPERTY:
            return {
                ...state,
                unitImagesByPropertyId: actions.payload
            };
        case types.FETCH_UNIT_IMAGES_BY_COMPANY_ID:
            return {
                ...state,
                unitImagesByCompanyId: actions.payload
            };
        case types.FETCH_COUNT_UNIT_IMAGES:
            return {
                ...state,
                unitImagesCount: actions.payload
            };
        case types.UPDATE_UNIT_IMAGE_BY_PROPERTY:
            let unitImagesByPropertyId = state.unitImagesByPropertyId ?
              state.unitImagesByPropertyId.slice(0) :
              []
            unitImagesByPropertyId[actions.payload.index] = actions.payload.response
            return {
                ...state,
                unitImagesByPropertyId
            }
        case types.UPDATE_UNIT_IMAGE:
            let unitImages = state.unitImages ? state.unitImages.slice(0) : []
            unitImages[actions.payload.index] = actions.payload.response
            return {
                ...state,
                unitImages
            }
        case types.DELETE_UNIT_IMAGE:
            let currentUnitImages = state.unitImages ? state.unitImages : []
            return {
                ...state,
                unitImages: [...currentUnitImages.slice(0, actions.index),
                    ...currentUnitImages.slice(actions.index + 1)
                ]
            }
        case types.DELETE_UNIT_IMAGE_BY_COMPANY_ID:
            return {
                ...state,
                unitImagesByCompanyId: state.unitImagesByCompanyId
                  .splice(actions.index, 1)
            }
        case types.DELETE_UNIT_IMAGE_BY_PROPERTY:
            let currentUnitImagesByPropertyId = state.unitImagesByPropertyId ?
              state.unitImagesByPropertyId : []
            return {
                ...state,
                unitImagesByPropertyId: [...currentUnitImagesByPropertyId.slice(0, actions.index),
                    ...currentUnitImagesByPropertyId.slice(actions.index + 1)
                ]
            }
        case types.CLEAR_COUNT_UNIT_IMAGES:
            return {
                ...state,
                unitImagesCount: null!
            }
        case types.CLEAR_UNIT_IMAGES: {
            return {
                ...state,
                unitImages: null,
            };
        }
        case types.CLEAR_UNIT_IMAGES_BY_COMPANY_ID:
            return {
                ...state,
                unitImagesByCompanyId: [],
                loading: true
            }
        case types.LOADING_UNIT_IMAGES:
            return {
                ...state,
                loading: actions.payload
            }
        default:
            return state;
    }
}
